import React from "react";
import { Card } from "semantic-ui-react";
import ScanCard from "./ScanCard";

const Documents = ({
	prescription,
	groupByDocumentType,
	focusedScan,
	disabled,
	isNotOriginal,
	openPrescriptionViewModal,
	openQRReaderPrescription,
	openScanDeleteConfirmOpen,
	movePrescriptionScan,
}) => (
	<Card.Group style={{ marginLeft: "10px" }}>
		{Object.entries(groupByDocumentType(prescription.scans))?.map(([key, scans]) =>
			scans?.map((scan, index) => (
				<ScanCard
					key={`sc-${scan.id}`}
					scan={scan}
					pageNb={index + 1}
					isSelected={focusedScan?.id === scan.id}
					onView={() => openPrescriptionViewModal(index)}
					onScan={() => openQRReaderPrescription(scan, index + 1)}
					onDelete={() => openScanDeleteConfirmOpen(scan)}
					disabled={disabled}
					isNotOriginal={isNotOriginal}
					index={index}
					movePrescriptionScan={movePrescriptionScan}
				/>
			))
		)}
	</Card.Group>
);

export default Documents;
